import React from 'react';
import {
  Col, Divider, Form, Input, InputNumber, Row, Switch,
} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { AnyObject } from '@triare/auth-redux';
import { PriceOverviewInfo } from '../../../../../hooks/api/tariffs';
import ResetFieldButton from '../../../../Common/ResetFieldButton';

interface PriceFormItem {
  name: keyof PriceOverviewInfo;
  label: string;
  type: 'number' | 'text';
  tooltip?: React.ReactNode;
}

const formatTooltip = (
  <div>
    Correct format is:
    {' '}
    <br />
    {'{value} {measure}'}
    {' '}
    <br />
    E.g &quot;11,00 ct / kWh&quot;
  </div>
);

const formItems: PriceFormItem[] = [
  { name: 'energyPriceLabel', label: 'Energiepreis netto (Regulärer Preis)', type: 'text' },
  {
    name: 'energyPriceValue',
    label: 'Energy price value',
    type: 'text',
    tooltip: formatTooltip,
  },
  { name: 'bonusLabel', label: '15% grüüün Bonus', type: 'text' },
  {
    name: 'bonusValue',
    label: '"Bonus" value',
    type: 'text',
    tooltip: formatTooltip,
  },
];

const defaultValues: Partial<Record<keyof PriceOverviewInfo, string>> = {
  energyPriceLabel: 'Energiepreis netto',
  // energyPriceValue: '',
  bonusLabel: '15% grüüün Bonus',
  // bonusValue: '',
};

interface PriceOverviewFieldsProps {
  id?: number;
  restField?: AnyObject;
}

function PriceOverviewFields({ id, restField = {} }: PriceOverviewFieldsProps) {
  const form = useFormInstance();

  const prefixArr = ['priceOverview'];

  if (id !== undefined) {
    prefixArr.unshift(id.toString());
  }

  return (
    <>
      <Divider>Preisübersicht</Divider>

      <Form.Item
        {...restField}
        label="Hide"
        name={[...prefixArr, 'isPriceOverviewVisible']}
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>

      <Row gutter={12}>
        {formItems.map(({
          name, label, type, tooltip,
        }) => (
          <Col span={12} key={name}>
            <Form.Item
              {...restField}
              label={(
                <div className="centered-content">
                  {label}
                  {defaultValues[name] ? (
                    <ResetFieldButton
                      onClick={() => form.setFieldValue([...prefixArr, name], defaultValues[name])}
                    />
                  ) : null}
                </div>
              )}
              name={[...prefixArr, name]}
              rules={[{ required: false, message: 'Please enter' }]}
              normalize={type === 'number' ? (value) => value && Number.parseFloat(value.toFixed(2)) : undefined}
              tooltip={tooltip}
            >
              {type === 'number' ? (
                <InputNumber placeholder="Please enter" style={{ width: '100%' }} step={1} />
              ) : (
                <Input placeholder="Please enter" />
              )}
            </Form.Item>
          </Col>
        ))}
      </Row>
    </>
  );
}

export default PriceOverviewFields;
